import React, { useId, useState } from "react";
import { ChevronDown, Info } from "lucide-react";

const DeliveryScreeningNotice = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const detailsId = useId();

  return (
    <section
      className="mt-3 rounded-[8px] border border-[#BFDBFE] bg-[#F8FBFF] p-3 font-inter"
      aria-labelledby={`${detailsId}-title`}
    >
      <div className="flex items-start gap-2.5">
        <span className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#DBEAFE] text-[#1D4ED8]">
          <Info className="h-4 w-4" aria-hidden="true" />
        </span>
        <div className="min-w-0 flex-1">
          <h3 id={`${detailsId}-title`} className="font-roboto text-[13px] font-semibold leading-4 text-primary">
            Update to AI screening reports
          </h3>
          <p className="mt-1 text-[12px] leading-5 text-secondary">
            Turnitin AI and similarity reports remain our primary customer reports. Other detection
            tools may be used only as supplementary internal review signals.
          </p>
          <button
            type="button"
            className="mt-1.5 inline-flex items-center gap-1 text-[11px] font-semibold text-[#1D4ED8] hover:underline"
            aria-expanded={isExpanded}
            aria-controls={detailsId}
            onClick={() => setIsExpanded((current) => !current)}
          >
            {isExpanded ? "Hide full update" : "Read full update"}
            <ChevronDown
              className={`h-3.5 w-3.5 transition-transform ${isExpanded ? "rotate-180" : ""}`}
              aria-hidden="true"
            />
          </button>
          {isExpanded && (
            <p id={detailsId} className="mt-2 border-t border-[#DBEAFE] pt-2 text-[12px] leading-5 text-gray">
              We have refined our screening process after evaluating newer AI-paraphrasing
              detection features. Because some of these features remain in beta, we will use other
              detection tools only as supplementary internal review signals where appropriate.
              Turnitin AI and similarity reports remain our primary customer reports.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default DeliveryScreeningNotice;
